import { ApiProblem } from '@/api/http';

/** Запрос не дошёл до сервера (нет сети, таймаут) — повод положить операцию в очередь. */
export function isNetworkError(e: unknown): boolean {
  return e instanceof ApiProblem && e.status === 0;
}
